(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nato-offer-cholesterol-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(root) {
      if (!root || root.dataset.natoOfferFaqInitialized === 'true') return;
      root.dataset.natoOfferFaqInitialized = 'true';
      root.querySelectorAll('.nato-offer-faq-button').forEach(function (button) {
        button.addEventListener('click', function () {
          var item = button.closest('.nato-offer-faq-item');
          var isOpen = item.classList.toggle('is-open');
          button.setAttribute('aria-expanded', String(isOpen));
        });
      });
    }

    function boot(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-nato-offer-faq]'), initFaq);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(document); });
    } else {
      boot(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      boot(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nato-offer-cholesterol-hero"] && !Shopify.designMode) return;
  try {
    
  /* =======================================================================
     nq2 GA4 ANALYTICS — Offer page (đặt ở hero = section đầu, luôn có mặt).
     - nq2_offer_view: bắn 1 lần khi trang offer load (kèm quiz/profile/score
       lấy từ URL params do quiz redirect sang).
     - nq2_offer_cta_click: delegated cho MỌI .nato-offer-cta trên trang
       (hero/recommend/dose/stats/cta...) -> đo tỉ lệ ra product page.
     ======================================================================= */
  (function () {
    if (window.__nq2OfferReady) return;
    window.__nq2OfferReady = true;

    function nq2EnsureGtag() {
      if (window.__nq2GtagReady) return;
      window.__nq2GtagReady = true;
      window.dataLayer = window.dataLayer || [];
      if (typeof window.gtag !== 'function') {
        window.gtag = function () { window.dataLayer.push(arguments); };
      }
      if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
        var s = document.createElement('script');
        s.async = true;
        s.src = 'https://www.googletagmanager.com/gtag/js?id=G-F7R9Y6YWDR';
        s.setAttribute('data-nq2-gtag', '1');
        document.head.appendChild(s);
        window.gtag('js', new Date());
        window.gtag('config', 'G-F7R9Y6YWDR');
      }
    }
    function track(name, params) {
      nq2EnsureGtag();
      try { window.gtag('event', name, params || {}); } catch (e) {}
    }
    function param(name) {
      try { return new URL(window.location.href).searchParams.get(name) || ''; }
      catch (e) { return ''; }
    }
    function concern() {
      try { return window.localStorage.getItem('nato_quiz_start_concern') || 'unknown'; }
      catch (e) { return 'unknown'; }
    }

    track('nq2_offer_view', {
      quiz_path: param('quiz') || 'unknown',
      concern: concern(),
      profile: param('profile'),
      score: param('score')
    });

    document.addEventListener('click', function (event) {
      var cta = event.target.closest('.nato-offer-cta');
      if (!cta) return;
      var section = cta.closest('[id^="nato-offer"], section');
      track('nq2_offer_cta_click', {
        quiz_path: param('quiz') || 'unknown',
        concern: concern(),
        cta_text: (cta.textContent || '').replace(/\s+/g, ' ').trim().substring(0, 90),
        cta_section: section ? (section.id || section.className.split(' ')[0] || 'unknown') : 'unknown',
        cta_href: cta.getAttribute('href') || ''
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nato-quiz-blood"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'nato_quiz_blood_answers';
    var PROFILE_KEY = 'nato_quiz_blood_profile';

    function getStored(key, fallback) {
      try {
        var raw = window.sessionStorage.getItem(key);
        return raw ? JSON.parse(raw) : fallback;
      } catch (error) {
        return fallback;
      }
    }

    function setStored(key, value) {
      try {
        window.sessionStorage.setItem(key, JSON.stringify(value));
      } catch (error) {}
    }

    function textFrom(element) {
      return (element && element.textContent ? element.textContent : '').replace(/\s+/g, ' ').trim();
    }

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function getProfile(answers) {
      var score = 0;
      Object.keys(answers).forEach(function (key) {
        var answer = answers[key];
        if (answer && typeof answer.score === 'number') score += answer.score;
      });
      var levelIndex = clamp(Math.round(score / 4), 0, 4);
      var profiles = [
        { status: 'Supported', slug: 'supported', marker: 10 },
        { status: 'Borderline', slug: 'borderline', marker: 30 },
        { status: 'Persistent Pressure', slug: 'persistent-pressure', marker: 50 },
        { status: 'Medication Pressure', slug: 'medication-pressure', marker: 70 },
        { status: 'Critical Window', slug: 'critical-window', marker: 90 }
      ];
      var profile = profiles[levelIndex];
      profile.score = score;
      return profile;
    }

    function hasTriedNattokinase(answers) {
      var answer = answers.nattokinase_experience;
      return Boolean(answer && (answer.value === 'currently_taking' || answer.value === 'tried_no_difference'));
    }

    function isLoadingStep(root, stepNumber) {
      var step = root.querySelector('[data-step="' + stepNumber + '"]');
      return Boolean(step && step.getAttribute('data-step-type') === 'loading');
    }

    function shouldSkipStep(stepNumber, answers) {
      return stepNumber === 4 && hasTriedNattokinase(answers);
    }

    function nextStepNumber(fromStep, total, answers) {
      var stepNumber = fromStep + 1;
      while (stepNumber <= total && shouldSkipStep(stepNumber, answers)) stepNumber += 1;
      return stepNumber;
    }

    function previousStepNumber(root, fromStep, answers) {
      var stepNumber = fromStep - 1;
      while (stepNumber > 1 && (shouldSkipStep(stepNumber, answers) || isLoadingStep(root, stepNumber))) stepNumber -= 1;
      return stepNumber;
    }

    function updateDoseBranch(root, answers) {
      var branchName = hasTriedNattokinase(answers) ? 'tried' : 'new';
      root.querySelectorAll('[data-dose-branch]').forEach(function (branch) {
        branch.hidden = branch.getAttribute('data-dose-branch') !== branchName;
      });
    }

    function updateProfile(root, answers) {
      var profile = getProfile(answers);
      var marker = root.querySelector('[data-profile-marker]');
      var status = root.querySelector('[data-profile-status]');
      var title = root.querySelector('[data-profile-alert-title]');
      var copy = root.querySelector('[data-profile-alert-copy]');
      if (marker) marker.style.left = profile.marker + '%';
      if (status) status.textContent = 'Needs Support';
      if (title) title.textContent = 'Needs Support';
      if (copy) copy.textContent = 'Your answers match arterial pressure strain and fibrin overload - sticky protein deposits that restrict blood flow and force the heart to pump harder. Based on your profile, a clinical-grade fibrin dissolution protocol is strongly indicated.';

      var duration = root.querySelector('[data-summary-duration]');
      var family = root.querySelector('[data-summary-family]');
      var medication = root.querySelector('[data-summary-medication]');
      var recommended = root.querySelector('[data-summary-recommended]');
      if (duration) duration.textContent = answers.duration ? answers.duration.label : 'Not answered yet';
      if (family) family.textContent = answers.family_history ? answers.family_history.label : 'Not answered yet';
      if (medication) medication.textContent = answers.medication ? answers.medication.label : 'Not answered yet';
      if (recommended) recommended.textContent = 'Clinical-grade 10,800 FU protocol';
      setStored(PROFILE_KEY, profile);
      return profile;
    }

    function initQuiz(root) {
      if (!root || root.dataset.natoBloodInitialized === 'true') return;
      root.dataset.natoBloodInitialized = 'true';

      var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
      var total = parseInt(root.getAttribute('data-total-steps'), 10) || steps.length;
      var count = root.querySelector('[data-quiz-count]');
      var progress = root.querySelector('[data-quiz-progress]');
      var back = root.querySelector('[data-quiz-back]');
      var startUrl = root.getAttribute('data-start-url') || '/pages/nato-quiz-start';
      var finalUrl = root.getAttribute('data-final-url');
      var answers = getStored(STORAGE_KEY, {});
      var currentStep = 1;
      var timer = null;

      function saveAnswers() {
        setStored(STORAGE_KEY, answers);
      }

      function setCurrent(stepNumber) {
        window.clearTimeout(timer);
        currentStep = clamp(stepNumber, 1, total);
        steps.forEach(function (step) {
          var isActive = parseInt(step.getAttribute('data-step'), 10) === currentStep;
          if (isActive) {
            step.hidden = false;
            window.requestAnimationFrame(function () { step.classList.add('is-active'); });
          } else {
            step.classList.remove('is-active');
            step.hidden = true;
          }
        });

        if (count) count.textContent = currentStep + ' of ' + total;
        if (progress) progress.style.width = ((currentStep / total) * 100) + '%';
        if (currentStep === 8) updateDoseBranch(root, answers);
        if (currentStep === 10) updateProfile(root, answers);

        var activeStep = root.querySelector('[data-step="' + currentStep + '"]');
        if (activeStep && activeStep.getAttribute('data-auto-next') === 'true') {
          timer = window.setTimeout(function () { setCurrent(nextStepNumber(currentStep, total, answers)); }, parseInt(activeStep.getAttribute('data-delay'), 10) || 2000);
        }
        if (activeStep && activeStep.getAttribute('data-final-step') === 'true') {
          var profile = updateProfile(root, answers);
          timer = window.setTimeout(function () {
            if (!finalUrl) return;
            var destination = new URL(finalUrl, window.location.origin);
            destination.searchParams.set('quiz', 'blood');
            destination.searchParams.set('profile', profile.slug);
            destination.searchParams.set('score', String(profile.score));
            window.location.href = destination.toString();
          }, parseInt(activeStep.getAttribute('data-delay'), 10) || 2600);
        }
      }

      function selectSingle(button) {
        var step = button.closest('[data-step]');
        var key = step.getAttribute('data-question-key');
        step.querySelectorAll('.nato-blood-option').forEach(function (item) { item.classList.remove('is-selected'); });
        button.classList.add('is-selected');
        answers[key] = {
          value: button.getAttribute('data-answer-value'),
          label: textFrom(button.querySelector('.nato-blood-option__label')),
          score: parseInt(button.getAttribute('data-score'), 10) || 0
        };
        saveAnswers();
        window.setTimeout(function () { setCurrent(nextStepNumber(currentStep, total, answers)); }, 180);
      }

      function updateMulti(step) {
        var selected = [];
        step.querySelectorAll('[data-multi-option]').forEach(function (input) {
          var label = input.closest('.nato-blood-check-option');
          label.classList.toggle('is-selected', input.checked);
          if (input.checked) selected.push({ value: input.value, label: textFrom(label.querySelector('.nato-blood-check-option__label')) });
        });
        answers[step.getAttribute('data-question-key')] = selected;
        saveAnswers();
        var continueButton = step.querySelector('[data-continue]');
        if (continueButton) continueButton.disabled = selected.length === 0;
      }

      root.addEventListener('click', function (event) {
        var option = event.target.closest('.nato-blood-option');
        if (option) {
          selectSingle(option);
          return;
        }

        var continueButton = event.target.closest('[data-continue]');
        if (continueButton && !continueButton.disabled) {
          setCurrent(nextStepNumber(currentStep, total, answers));
        }
      });

      root.addEventListener('change', function (event) {
        var input = event.target.closest('[data-multi-option]');
        if (!input) return;
        updateMulti(input.closest('[data-step]'));
      });

      if (back) {
        back.addEventListener('click', function () {
          if (currentStep > 1) {
            setCurrent(previousStepNumber(root, currentStep, answers));
          } else {
            window.location.href = startUrl;
          }
        });
      }

      setCurrent(1);
    }

    function boot(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-nato-blood-quiz]'), initQuiz);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(document); });
    } else {
      boot(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      boot(event.target);
    });
  })();

  /* =======================================================================
     nq2 GA4 ANALYTICS — decoupled tracker (does NOT touch the quiz engine)
     - Quan sát DOM (MutationObserver) để biết bước đang hiển thị.
     - Mỗi bước = 1 event name riêng (nq2_s_NN_...), bắn 1 LẦN ở lần đầu tới
       bước đó -> back/tới lại KHÔNG bắn trùng -> drop-off chính xác.
     - quiz_path & concern đính kèm mọi event để tách theo path / 5 concern.
     ======================================================================= */
  (function () {
    var QUIZ_PATH = 'blood';
    var OPTION_CLASS = 'nato-blood-option';
    var PROFILE_KEY = 'nato_quiz_blood_profile';
    var ROOT_SELECTOR = '[data-nato-blood-quiz]';
    var STEP_EVENT = {
      1: 'nq2_s_01_age', 2: 'nq2_s_02_situation', 3: 'nq2_s_03_nattokinase',
      4: 'nq2_s_04_education_a', 5: 'nq2_s_05_duration', 6: 'nq2_s_06_family',
      7: 'nq2_s_07_medication', 8: 'nq2_s_08_education_b', 9: 'nq2_s_09_loading_a',
      10: 'nq2_s_10_profile', 11: 'nq2_s_11_tried', 12: 'nq2_s_12_education_c',
      13: 'nq2_s_13_motivation', 14: 'nq2_s_14_complete'
    };

    function nq2EnsureGtag() {
      if (window.__nq2GtagReady) return;
      window.__nq2GtagReady = true;
      window.dataLayer = window.dataLayer || [];
      if (typeof window.gtag !== 'function') {
        window.gtag = function () { window.dataLayer.push(arguments); };
      }
      if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
        var s = document.createElement('script');
        s.async = true;
        s.src = 'https://www.googletagmanager.com/gtag/js?id=G-F7R9Y6YWDR';
        s.setAttribute('data-nq2-gtag', '1');
        document.head.appendChild(s);
        window.gtag('js', new Date());
        window.gtag('config', 'G-F7R9Y6YWDR');
      }
    }
    function track(name, params) {
      nq2EnsureGtag();
      try { window.gtag('event', name, params || {}); } catch (e) {}
    }
    function getConcern() {
      try { return window.localStorage.getItem('nato_quiz_start_concern') || 'unknown'; }
      catch (e) { return 'unknown'; }
    }
    function readProfile() {
      try { return JSON.parse(window.sessionStorage.getItem(PROFILE_KEY) || 'null'); }
      catch (e) { return null; }
    }

    function initTracker(root) {
      if (!root || root.__nq2Tracked) return;
      root.__nq2Tracked = true;

      var concern = getConcern();
      var viewed = {}, answered = {}, maxStep = 0, done = false, abandonSent = false;
      var stepStart = Date.now();

      track('nq2_quiz_view', { quiz_path: QUIZ_PATH, concern: concern });

      function activeStepEl() { return root.querySelector('[data-step]:not([hidden])'); }

      function onStep(el) {
        if (!el) return;
        var n = parseInt(el.getAttribute('data-step'), 10);
        if (!n || viewed[n]) return;
        viewed[n] = true;
        if (n > maxStep) maxStep = n;
        stepStart = Date.now();
        track(STEP_EVENT[n] || ('nq2_s_x_' + n), {
          quiz_path: QUIZ_PATH, concern: concern,
          step_index: n,
          step_type: el.getAttribute('data-step-type') || '',
          step_key: el.getAttribute('data-question-key') || (el.getAttribute('data-step-type') || '')
        });
        if (el.getAttribute('data-final-step') === 'true') {
          done = true;
          var p = readProfile();
          track('nq2_quiz_complete', {
            quiz_path: QUIZ_PATH, concern: concern,
            score: p && typeof p.score === 'number' ? p.score : null,
            profile: p ? p.slug : null
          });
        }
      }

      onStep(activeStepEl());
      var observer = new MutationObserver(function () { onStep(activeStepEl()); });
      root.querySelectorAll('[data-step]').forEach(function (s) {
        observer.observe(s, { attributes: true, attributeFilter: ['hidden', 'class'] });
      });

      root.addEventListener('click', function (event) {
        var opt = event.target.closest('.' + OPTION_CLASS);
        if (opt) {
          var step = opt.closest('[data-step]');
          var key = step ? (step.getAttribute('data-question-key') || '') : '';
          var isChange = !!answered[key];
          answered[key] = true;
          track('nq2_answer', {
            quiz_path: QUIZ_PATH, concern: concern, step_key: key,
            answer_value: (opt.getAttribute('data-answer-value') || '').substring(0, 90),
            score: parseInt(opt.getAttribute('data-score'), 10) || 0,
            is_multi: false, is_change: isChange,
            seconds_on_step: Math.round((Date.now() - stepStart) / 1000)
          });
          return;
        }
        var cont = event.target.closest('[data-continue]');
        if (cont && !cont.disabled) {
          var active = activeStepEl();
          if (active && active.getAttribute('data-step-type') === 'multi') {
            var mkey = active.getAttribute('data-question-key') || '';
            var vals = [];
            active.querySelectorAll('[data-multi-option]').forEach(function (i) {
              if (i.checked) vals.push(i.value);
            });
            var mChange = !!answered[mkey];
            answered[mkey] = true;
            track('nq2_answer', {
              quiz_path: QUIZ_PATH, concern: concern, step_key: mkey,
              answer_values: vals.join(' | ').substring(0, 90),
              answer_count: vals.length, is_multi: true, is_change: mChange,
              seconds_on_step: Math.round((Date.now() - stepStart) / 1000)
            });
          }
        }
      });

      function sendAbandon() {
        if (done || abandonSent || maxStep < 1) return;
        abandonSent = true;
        track('nq2_quiz_abandon', {
          quiz_path: QUIZ_PATH, concern: concern,
          last_step_index: maxStep,
          last_step_event: STEP_EVENT[maxStep] || ('nq2_s_x_' + maxStep)
        });
      }
      window.addEventListener('pagehide', sendAbandon);
      window.addEventListener('beforeunload', sendAbandon);
    }

    function bootTracker(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll(ROOT_SELECTOR), initTracker);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { bootTracker(document); });
    } else {
      bootTracker(document);
    }
    document.addEventListener('shopify:section:load', function (event) { bootTracker(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nato-quiz-cholesterol"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'nato_quiz_cholesterol_answers';
    var PROFILE_KEY = 'nato_quiz_cholesterol_profile';

    function getStored(key, fallback) {
      try {
        var raw = window.sessionStorage.getItem(key);
        return raw ? JSON.parse(raw) : fallback;
      } catch (error) {
        return fallback;
      }
    }

    function setStored(key, value) {
      try {
        window.sessionStorage.setItem(key, JSON.stringify(value));
      } catch (error) {}
    }

    function textFrom(element) {
      return (element && element.textContent ? element.textContent : '').replace(/\s+/g, ' ').trim();
    }

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function getProfile(answers) {
      var score = 0;
      Object.keys(answers).forEach(function (key) {
        var answer = answers[key];
        if (answer && typeof answer.score === 'number') score += answer.score;
      });
      var levelIndex = clamp(Math.round(score / 4), 0, 4);
      var profiles = [
        { status: 'Supported', slug: 'supported', marker: 10 },
        { status: 'Early Buildup', slug: 'early-buildup', marker: 30 },
        { status: 'Managed-Not Cleared', slug: 'managed-not-cleared', marker: 50 },
        { status: 'Active Buildup', slug: 'active-buildup', marker: 70 },
        { status: 'Critical Window', slug: 'critical-window', marker: 90 }
      ];
      var profile = profiles[levelIndex];
      profile.score = score;
      return profile;
    }

    function hasTriedNattokinase(answers) {
      var answer = answers.nattokinase_experience;
      return Boolean(answer && (answer.value === 'currently_taking' || answer.value === 'tried_no_difference'));
    }

    function isLoadingStep(root, stepNumber) {
      var step = root.querySelector('[data-step="' + stepNumber + '"]');
      return Boolean(step && step.getAttribute('data-step-type') === 'loading');
    }

    function shouldSkipStep(stepNumber, answers) {
      return stepNumber === 4 && hasTriedNattokinase(answers);
    }

    function nextStepNumber(fromStep, total, answers) {
      var stepNumber = fromStep + 1;
      while (stepNumber <= total && shouldSkipStep(stepNumber, answers)) stepNumber += 1;
      return stepNumber;
    }

    function previousStepNumber(root, fromStep, answers) {
      var stepNumber = fromStep - 1;
      while (stepNumber > 1 && (shouldSkipStep(stepNumber, answers) || isLoadingStep(root, stepNumber))) stepNumber -= 1;
      return stepNumber;
    }

    function updateDoseBranch(root, answers) {
      var branchName = hasTriedNattokinase(answers) ? 'tried' : 'new';
      root.querySelectorAll('[data-dose-branch]').forEach(function (branch) {
        branch.hidden = branch.getAttribute('data-dose-branch') !== branchName;
      });
    }

    function updateProfile(root, answers) {
      var profile = getProfile(answers);
      var marker = root.querySelector('[data-profile-marker]');
      var status = root.querySelector('[data-profile-status]');
      var title = root.querySelector('[data-profile-alert-title]');
      var copy = root.querySelector('[data-profile-alert-copy]');
      if (marker) marker.style.left = profile.marker + '%';
      if (status) status.textContent = 'Needs Support';
      if (title) title.textContent = 'Needs Support';
      if (copy) copy.textContent = 'Your answers match arterial fibrin overload \u2014 sticky protein deposits that narrow vessels and restrict blood flow. Based on your profile, a clinical-grade fibrin dissolution protocol is strongly indicated.';

      var duration = root.querySelector('[data-summary-duration]');
      var family = root.querySelector('[data-summary-family]');
      var medication = root.querySelector('[data-summary-medication]');
      var recommended = root.querySelector('[data-summary-recommended]');
      if (duration) duration.textContent = answers.duration ? answers.duration.label : 'Not answered yet';
      if (family) family.textContent = answers.family_history ? answers.family_history.label : 'Not answered yet';
      if (medication) medication.textContent = answers.medication ? answers.medication.label : 'Not answered yet';
      if (recommended) recommended.textContent = 'Clinical-grade 10,800 FU protocol';
      setStored(PROFILE_KEY, profile);
      return profile;
    }

    function initQuiz(root) {
      if (!root || root.dataset.natoCholesterolInitialized === 'true') return;
      root.dataset.natoCholesterolInitialized = 'true';

      var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
      var total = parseInt(root.getAttribute('data-total-steps'), 10) || steps.length;
      var count = root.querySelector('[data-quiz-count]');
      var progress = root.querySelector('[data-quiz-progress]');
      var back = root.querySelector('[data-quiz-back]');
      var startUrl = root.getAttribute('data-start-url') || '/pages/nato-quiz-start';
      var finalUrl = root.getAttribute('data-final-url');
      var answers = getStored(STORAGE_KEY, {});
      var currentStep = 1;
      var timer = null;

      function saveAnswers() {
        setStored(STORAGE_KEY, answers);
      }

      function setCurrent(stepNumber) {
        window.clearTimeout(timer);
        currentStep = clamp(stepNumber, 1, total);
        steps.forEach(function (step) {
          var isActive = parseInt(step.getAttribute('data-step'), 10) === currentStep;
          if (isActive) {
            step.hidden = false;
            window.requestAnimationFrame(function () { step.classList.add('is-active'); });
          } else {
            step.classList.remove('is-active');
            step.hidden = true;
          }
        });

        if (count) count.textContent = currentStep + ' of ' + total;
        if (progress) progress.style.width = ((currentStep / total) * 100) + '%';
        if (currentStep === 8) updateDoseBranch(root, answers);
        if (currentStep === 10) updateProfile(root, answers);

        var activeStep = root.querySelector('[data-step="' + currentStep + '"]');
        if (activeStep && activeStep.getAttribute('data-auto-next') === 'true') {
          timer = window.setTimeout(function () { setCurrent(nextStepNumber(currentStep, total, answers)); }, parseInt(activeStep.getAttribute('data-delay'), 10) || 2000);
        }
        if (activeStep && activeStep.getAttribute('data-final-step') === 'true') {
          var profile = updateProfile(root, answers);
          timer = window.setTimeout(function () {
            if (!finalUrl) return;
            var destination = new URL(finalUrl, window.location.origin);
            destination.searchParams.set('quiz', 'cholesterol');
            destination.searchParams.set('profile', profile.slug);
            destination.searchParams.set('score', String(profile.score));
            window.location.href = destination.toString();
          }, parseInt(activeStep.getAttribute('data-delay'), 10) || 2600);
        }
      }

      function selectSingle(button) {
        var step = button.closest('[data-step]');
        var key = step.getAttribute('data-question-key');
        step.querySelectorAll('.nato-cholesterol-option').forEach(function (item) { item.classList.remove('is-selected'); });
        button.classList.add('is-selected');
        answers[key] = {
          value: button.getAttribute('data-answer-value'),
          label: textFrom(button.querySelector('.nato-cholesterol-option__label')),
          score: parseInt(button.getAttribute('data-score'), 10) || 0
        };
        saveAnswers();
        window.setTimeout(function () { setCurrent(nextStepNumber(currentStep, total, answers)); }, 180);
      }

      function updateMulti(step) {
        var selected = [];
        step.querySelectorAll('[data-multi-option]').forEach(function (input) {
          var label = input.closest('.nato-cholesterol-check-option');
          label.classList.toggle('is-selected', input.checked);
          if (input.checked) selected.push({ value: input.value, label: textFrom(label.querySelector('.nato-cholesterol-check-option__label')) });
        });
        answers[step.getAttribute('data-question-key')] = selected;
        saveAnswers();
        var continueButton = step.querySelector('[data-continue]');
        if (continueButton) continueButton.disabled = selected.length === 0;
      }

      root.addEventListener('click', function (event) {
        var option = event.target.closest('.nato-cholesterol-option');
        if (option) {
          selectSingle(option);
          return;
        }

        var continueButton = event.target.closest('[data-continue]');
        if (continueButton && !continueButton.disabled) {
          setCurrent(nextStepNumber(currentStep, total, answers));
        }
      });

      root.addEventListener('change', function (event) {
        var input = event.target.closest('[data-multi-option]');
        if (!input) return;
        updateMulti(input.closest('[data-step]'));
      });

      if (back) {
        back.addEventListener('click', function () {
          if (currentStep > 1) {
            setCurrent(previousStepNumber(root, currentStep, answers));
          } else {
            window.location.href = startUrl;
          }
        });
      }

      setCurrent(1);
    }

    function boot(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-nato-cholesterol-quiz]'), initQuiz);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(document); });
    } else {
      boot(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      boot(event.target);
    });
  })();

  /* =======================================================================
     nq2 GA4 ANALYTICS — decoupled tracker (does NOT touch the quiz engine)
     - Quan sát DOM (MutationObserver) để biết bước đang hiển thị.
     - Mỗi bước = 1 event name riêng (nq2_s_NN_...), bắn 1 LẦN ở lần đầu tới
       bước đó -> back/tới lại KHÔNG bắn trùng -> drop-off chính xác.
     - quiz_path & concern đính kèm mọi event để tách theo path / 5 concern.
     ======================================================================= */
  (function () {
    var QUIZ_PATH = 'cholesterol';
    var OPTION_CLASS = 'nato-cholesterol-option';
    var PROFILE_KEY = 'nato_quiz_cholesterol_profile';
    var ROOT_SELECTOR = '[data-nato-cholesterol-quiz]';
    var STEP_EVENT = {
      1: 'nq2_s_01_age', 2: 'nq2_s_02_situation', 3: 'nq2_s_03_nattokinase',
      4: 'nq2_s_04_education_a', 5: 'nq2_s_05_duration', 6: 'nq2_s_06_family',
      7: 'nq2_s_07_medication', 8: 'nq2_s_08_education_b', 9: 'nq2_s_09_loading_a',
      10: 'nq2_s_10_profile', 11: 'nq2_s_11_tried', 12: 'nq2_s_12_education_c',
      13: 'nq2_s_13_motivation', 14: 'nq2_s_14_complete'
    };

    function nq2EnsureGtag() {
      if (window.__nq2GtagReady) return;
      window.__nq2GtagReady = true;
      window.dataLayer = window.dataLayer || [];
      if (typeof window.gtag !== 'function') {
        window.gtag = function () { window.dataLayer.push(arguments); };
      }
      if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
        var s = document.createElement('script');
        s.async = true;
        s.src = 'https://www.googletagmanager.com/gtag/js?id=G-F7R9Y6YWDR';
        s.setAttribute('data-nq2-gtag', '1');
        document.head.appendChild(s);
        window.gtag('js', new Date());
        window.gtag('config', 'G-F7R9Y6YWDR');
      }
    }
    function track(name, params) {
      nq2EnsureGtag();
      try { window.gtag('event', name, params || {}); } catch (e) {}
    }
    function getConcern() {
      try { return window.localStorage.getItem('nato_quiz_start_concern') || 'unknown'; }
      catch (e) { return 'unknown'; }
    }
    function readProfile() {
      try { return JSON.parse(window.sessionStorage.getItem(PROFILE_KEY) || 'null'); }
      catch (e) { return null; }
    }

    function initTracker(root) {
      if (!root || root.__nq2Tracked) return;
      root.__nq2Tracked = true;

      var concern = getConcern();
      var viewed = {}, answered = {}, maxStep = 0, done = false, abandonSent = false;
      var stepStart = Date.now();

      track('nq2_quiz_view', { quiz_path: QUIZ_PATH, concern: concern });

      function activeStepEl() { return root.querySelector('[data-step]:not([hidden])'); }

      function onStep(el) {
        if (!el) return;
        var n = parseInt(el.getAttribute('data-step'), 10);
        if (!n || viewed[n]) return;
        viewed[n] = true;
        if (n > maxStep) maxStep = n;
        stepStart = Date.now();
        track(STEP_EVENT[n] || ('nq2_s_x_' + n), {
          quiz_path: QUIZ_PATH, concern: concern,
          step_index: n,
          step_type: el.getAttribute('data-step-type') || '',
          step_key: el.getAttribute('data-question-key') || (el.getAttribute('data-step-type') || '')
        });
        if (el.getAttribute('data-final-step') === 'true') {
          done = true;
          var p = readProfile();
          track('nq2_quiz_complete', {
            quiz_path: QUIZ_PATH, concern: concern,
            score: p && typeof p.score === 'number' ? p.score : null,
            profile: p ? p.slug : null
          });
        }
      }

      onStep(activeStepEl());
      var observer = new MutationObserver(function () { onStep(activeStepEl()); });
      root.querySelectorAll('[data-step]').forEach(function (s) {
        observer.observe(s, { attributes: true, attributeFilter: ['hidden', 'class'] });
      });

      root.addEventListener('click', function (event) {
        var opt = event.target.closest('.' + OPTION_CLASS);
        if (opt) {
          var step = opt.closest('[data-step]');
          var key = step ? (step.getAttribute('data-question-key') || '') : '';
          var isChange = !!answered[key];
          answered[key] = true;
          track('nq2_answer', {
            quiz_path: QUIZ_PATH, concern: concern, step_key: key,
            answer_value: (opt.getAttribute('data-answer-value') || '').substring(0, 90),
            score: parseInt(opt.getAttribute('data-score'), 10) || 0,
            is_multi: false, is_change: isChange,
            seconds_on_step: Math.round((Date.now() - stepStart) / 1000)
          });
          return;
        }
        var cont = event.target.closest('[data-continue]');
        if (cont && !cont.disabled) {
          var active = activeStepEl();
          if (active && active.getAttribute('data-step-type') === 'multi') {
            var mkey = active.getAttribute('data-question-key') || '';
            var vals = [];
            active.querySelectorAll('[data-multi-option]').forEach(function (i) {
              if (i.checked) vals.push(i.value);
            });
            var mChange = !!answered[mkey];
            answered[mkey] = true;
            track('nq2_answer', {
              quiz_path: QUIZ_PATH, concern: concern, step_key: mkey,
              answer_values: vals.join(' | ').substring(0, 90),
              answer_count: vals.length, is_multi: true, is_change: mChange,
              seconds_on_step: Math.round((Date.now() - stepStart) / 1000)
            });
          }
        }
      });

      function sendAbandon() {
        if (done || abandonSent || maxStep < 1) return;
        abandonSent = true;
        track('nq2_quiz_abandon', {
          quiz_path: QUIZ_PATH, concern: concern,
          last_step_index: maxStep,
          last_step_event: STEP_EVENT[maxStep] || ('nq2_s_x_' + maxStep)
        });
      }
      window.addEventListener('pagehide', sendAbandon);
      window.addEventListener('beforeunload', sendAbandon);
    }

    function bootTracker(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll(ROOT_SELECTOR), initTracker);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { bootTracker(document); });
    } else {
      bootTracker(document);
    }
    document.addEventListener('shopify:section:load', function (event) { bootTracker(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nato-quiz-energy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'nato_quiz_energy_answers';
    var PROFILE_KEY = 'nato_quiz_energy_profile';

    function getStored(key, fallback) {
      try {
        var raw = window.sessionStorage.getItem(key);
        return raw ? JSON.parse(raw) : fallback;
      } catch (error) {
        return fallback;
      }
    }

    function setStored(key, value) {
      try {
        window.sessionStorage.setItem(key, JSON.stringify(value));
      } catch (error) {}
    }

    function textFrom(element) {
      return (element && element.textContent ? element.textContent : '').replace(/\s+/g, ' ').trim();
    }

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function getProfile(answers) {
      var score = 0;
      Object.keys(answers).forEach(function (key) {
        var answer = answers[key];
        if (answer && typeof answer.score === 'number') score += answer.score;
      });
      var levelIndex = clamp(Math.round(score / 4), 0, 4);
      var profiles = [
        { status: 'Supported', slug: 'supported', marker: 10 },
        { status: 'Circulation Drag', slug: 'circulation-drag', marker: 30 },
        { status: 'Low Energy Signals', slug: 'low-energy-signals', marker: 50 },
        { status: 'Active Fatigue', slug: 'active-fatigue', marker: 70 },
        { status: 'Critical Window', slug: 'critical-window', marker: 90 }
      ];
      var profile = profiles[levelIndex];
      profile.score = score;
      return profile;
    }

    function hasTriedNattokinase(answers) {
      var answer = answers.nattokinase_experience;
      return Boolean(answer && (answer.value === 'currently_taking' || answer.value === 'tried_no_difference'));
    }

    function isLoadingStep(root, stepNumber) {
      var step = root.querySelector('[data-step="' + stepNumber + '"]');
      return Boolean(step && step.getAttribute('data-step-type') === 'loading');
    }

    function shouldSkipStep(stepNumber, answers) {
      return stepNumber === 4 && hasTriedNattokinase(answers);
    }

    function nextStepNumber(fromStep, total, answers) {
      var stepNumber = fromStep + 1;
      while (stepNumber <= total && shouldSkipStep(stepNumber, answers)) stepNumber += 1;
      return stepNumber;
    }

    function previousStepNumber(root, fromStep, answers) {
      var stepNumber = fromStep - 1;
      while (stepNumber > 1 && (shouldSkipStep(stepNumber, answers) || isLoadingStep(root, stepNumber))) stepNumber -= 1;
      return stepNumber;
    }

    function updateDoseBranch(root, answers) {
      var branchName = hasTriedNattokinase(answers) ? 'tried' : 'new';
      root.querySelectorAll('[data-dose-branch]').forEach(function (branch) {
        branch.hidden = branch.getAttribute('data-dose-branch') !== branchName;
      });
    }

    function updateProfile(root, answers) {
      var profile = getProfile(answers);
      var marker = root.querySelector('[data-profile-marker]');
      var status = root.querySelector('[data-profile-status]');
      var title = root.querySelector('[data-profile-alert-title]');
      var copy = root.querySelector('[data-profile-alert-copy]');
      if (marker) marker.style.left = profile.marker + '%';
      if (status) status.textContent = 'Needs Support';
      if (title) title.textContent = 'Needs Support';
      if (copy) copy.textContent = 'Your answers match restricted circulation and low-energy cardiovascular strain. Based on your profile, a clinical-grade fibrin dissolution protocol is strongly indicated.';

      var duration = root.querySelector('[data-summary-duration]');
      var family = root.querySelector('[data-summary-family]');
      var medication = root.querySelector('[data-summary-medication]');
      var recommended = root.querySelector('[data-summary-recommended]');
      if (duration) duration.textContent = answers.duration ? answers.duration.label : 'Not answered yet';
      if (family) family.textContent = answers.family_history ? answers.family_history.label : 'Not answered yet';
      if (medication) medication.textContent = answers.medication ? answers.medication.label : 'Not answered yet';
      if (recommended) recommended.textContent = 'Clinical-grade 10,800 FU protocol';
      setStored(PROFILE_KEY, profile);
      return profile;
    }

    function initQuiz(root) {
      if (!root || root.dataset.natoEnergyInitialized === 'true') return;
      root.dataset.natoEnergyInitialized = 'true';

      var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
      var total = parseInt(root.getAttribute('data-total-steps'), 10) || steps.length;
      var count = root.querySelector('[data-quiz-count]');
      var progress = root.querySelector('[data-quiz-progress]');
      var back = root.querySelector('[data-quiz-back]');
      var startUrl = root.getAttribute('data-start-url') || '/pages/nato-quiz-start';
      var finalUrl = root.getAttribute('data-final-url');
      var answers = getStored(STORAGE_KEY, {});
      var currentStep = 1;
      var timer = null;

      function saveAnswers() {
        setStored(STORAGE_KEY, answers);
      }

      function setCurrent(stepNumber) {
        window.clearTimeout(timer);
        currentStep = clamp(stepNumber, 1, total);
        steps.forEach(function (step) {
          var isActive = parseInt(step.getAttribute('data-step'), 10) === currentStep;
          if (isActive) {
            step.hidden = false;
            window.requestAnimationFrame(function () { step.classList.add('is-active'); });
          } else {
            step.classList.remove('is-active');
            step.hidden = true;
          }
        });

        if (count) count.textContent = currentStep + ' of ' + total;
        if (progress) progress.style.width = ((currentStep / total) * 100) + '%';
        if (currentStep === 8) updateDoseBranch(root, answers);
        if (currentStep === 10) updateProfile(root, answers);

        var activeStep = root.querySelector('[data-step="' + currentStep + '"]');
        if (activeStep && activeStep.getAttribute('data-auto-next') === 'true') {
          timer = window.setTimeout(function () { setCurrent(nextStepNumber(currentStep, total, answers)); }, parseInt(activeStep.getAttribute('data-delay'), 10) || 2000);
        }
        if (activeStep && activeStep.getAttribute('data-final-step') === 'true') {
          var profile = updateProfile(root, answers);
          timer = window.setTimeout(function () {
            if (!finalUrl) return;
            var destination = new URL(finalUrl, window.location.origin);
            destination.searchParams.set('quiz', 'energy');
            destination.searchParams.set('profile', profile.slug);
            destination.searchParams.set('score', String(profile.score));
            window.location.href = destination.toString();
          }, parseInt(activeStep.getAttribute('data-delay'), 10) || 2600);
        }
      }

      function selectSingle(button) {
        var step = button.closest('[data-step]');
        var key = step.getAttribute('data-question-key');
        step.querySelectorAll('.nato-energy-option').forEach(function (item) { item.classList.remove('is-selected'); });
        button.classList.add('is-selected');
        answers[key] = {
          value: button.getAttribute('data-answer-value'),
          label: textFrom(button.querySelector('.nato-energy-option__label')),
          score: parseInt(button.getAttribute('data-score'), 10) || 0
        };
        saveAnswers();
        window.setTimeout(function () { setCurrent(nextStepNumber(currentStep, total, answers)); }, 180);
      }

      function updateMulti(step) {
        var selected = [];
        step.querySelectorAll('[data-multi-option]').forEach(function (input) {
          var label = input.closest('.nato-energy-check-option');
          label.classList.toggle('is-selected', input.checked);
          if (input.checked) selected.push({ value: input.value, label: textFrom(label.querySelector('.nato-energy-check-option__label')) });
        });
        answers[step.getAttribute('data-question-key')] = selected;
        saveAnswers();
        var continueButton = step.querySelector('[data-continue]');
        if (continueButton) continueButton.disabled = selected.length === 0;
      }

      root.addEventListener('click', function (event) {
        var option = event.target.closest('.nato-energy-option');
        if (option) {
          selectSingle(option);
          return;
        }

        var continueButton = event.target.closest('[data-continue]');
        if (continueButton && !continueButton.disabled) {
          setCurrent(nextStepNumber(currentStep, total, answers));
        }
      });

      root.addEventListener('change', function (event) {
        var input = event.target.closest('[data-multi-option]');
        if (!input) return;
        updateMulti(input.closest('[data-step]'));
      });

      if (back) {
        back.addEventListener('click', function () {
          if (currentStep > 1) {
            setCurrent(previousStepNumber(root, currentStep, answers));
          } else {
            window.location.href = startUrl;
          }
        });
      }

      setCurrent(1);
    }

    function boot(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-nato-energy-quiz]'), initQuiz);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(document); });
    } else {
      boot(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      boot(event.target);
    });
  })();

  /* =======================================================================
     nq2 GA4 ANALYTICS — decoupled tracker (does NOT touch the quiz engine)
     - Quan sát DOM (MutationObserver) để biết bước đang hiển thị.
     - Mỗi bước = 1 event name riêng (nq2_s_NN_...), bắn 1 LẦN ở lần đầu tới
       bước đó -> back/tới lại KHÔNG bắn trùng -> drop-off chính xác.
     - quiz_path & concern đính kèm mọi event để tách theo path / 5 concern.
     ======================================================================= */
  (function () {
    var QUIZ_PATH = 'energy';
    var OPTION_CLASS = 'nato-energy-option';
    var PROFILE_KEY = 'nato_quiz_energy_profile';
    var ROOT_SELECTOR = '[data-nato-energy-quiz]';
    var STEP_EVENT = {
      1: 'nq2_s_01_age', 2: 'nq2_s_02_situation', 3: 'nq2_s_03_nattokinase',
      4: 'nq2_s_04_education_a', 5: 'nq2_s_05_duration', 6: 'nq2_s_06_family',
      7: 'nq2_s_07_medication', 8: 'nq2_s_08_education_b', 9: 'nq2_s_09_loading_a',
      10: 'nq2_s_10_profile', 11: 'nq2_s_11_tried', 12: 'nq2_s_12_education_c',
      13: 'nq2_s_13_motivation', 14: 'nq2_s_14_complete'
    };

    function nq2EnsureGtag() {
      if (window.__nq2GtagReady) return;
      window.__nq2GtagReady = true;
      window.dataLayer = window.dataLayer || [];
      if (typeof window.gtag !== 'function') {
        window.gtag = function () { window.dataLayer.push(arguments); };
      }
      if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
        var s = document.createElement('script');
        s.async = true;
        s.src = 'https://www.googletagmanager.com/gtag/js?id=G-F7R9Y6YWDR';
        s.setAttribute('data-nq2-gtag', '1');
        document.head.appendChild(s);
        window.gtag('js', new Date());
        window.gtag('config', 'G-F7R9Y6YWDR');
      }
    }
    function track(name, params) {
      nq2EnsureGtag();
      try { window.gtag('event', name, params || {}); } catch (e) {}
    }
    function getConcern() {
      try { return window.localStorage.getItem('nato_quiz_start_concern') || 'unknown'; }
      catch (e) { return 'unknown'; }
    }
    function readProfile() {
      try { return JSON.parse(window.sessionStorage.getItem(PROFILE_KEY) || 'null'); }
      catch (e) { return null; }
    }

    function initTracker(root) {
      if (!root || root.__nq2Tracked) return;
      root.__nq2Tracked = true;

      var concern = getConcern();
      var viewed = {}, answered = {}, maxStep = 0, done = false, abandonSent = false;
      var stepStart = Date.now();

      track('nq2_quiz_view', { quiz_path: QUIZ_PATH, concern: concern });

      function activeStepEl() { return root.querySelector('[data-step]:not([hidden])'); }

      function onStep(el) {
        if (!el) return;
        var n = parseInt(el.getAttribute('data-step'), 10);
        if (!n || viewed[n]) return;
        viewed[n] = true;
        if (n > maxStep) maxStep = n;
        stepStart = Date.now();
        track(STEP_EVENT[n] || ('nq2_s_x_' + n), {
          quiz_path: QUIZ_PATH, concern: concern,
          step_index: n,
          step_type: el.getAttribute('data-step-type') || '',
          step_key: el.getAttribute('data-question-key') || (el.getAttribute('data-step-type') || '')
        });
        if (el.getAttribute('data-final-step') === 'true') {
          done = true;
          var p = readProfile();
          track('nq2_quiz_complete', {
            quiz_path: QUIZ_PATH, concern: concern,
            score: p && typeof p.score === 'number' ? p.score : null,
            profile: p ? p.slug : null
          });
        }
      }

      onStep(activeStepEl());
      var observer = new MutationObserver(function () { onStep(activeStepEl()); });
      root.querySelectorAll('[data-step]').forEach(function (s) {
        observer.observe(s, { attributes: true, attributeFilter: ['hidden', 'class'] });
      });

      root.addEventListener('click', function (event) {
        var opt = event.target.closest('.' + OPTION_CLASS);
        if (opt) {
          var step = opt.closest('[data-step]');
          var key = step ? (step.getAttribute('data-question-key') || '') : '';
          var isChange = !!answered[key];
          answered[key] = true;
          track('nq2_answer', {
            quiz_path: QUIZ_PATH, concern: concern, step_key: key,
            answer_value: (opt.getAttribute('data-answer-value') || '').substring(0, 90),
            score: parseInt(opt.getAttribute('data-score'), 10) || 0,
            is_multi: false, is_change: isChange,
            seconds_on_step: Math.round((Date.now() - stepStart) / 1000)
          });
          return;
        }
        var cont = event.target.closest('[data-continue]');
        if (cont && !cont.disabled) {
          var active = activeStepEl();
          if (active && active.getAttribute('data-step-type') === 'multi') {
            var mkey = active.getAttribute('data-question-key') || '';
            var vals = [];
            active.querySelectorAll('[data-multi-option]').forEach(function (i) {
              if (i.checked) vals.push(i.value);
            });
            var mChange = !!answered[mkey];
            answered[mkey] = true;
            track('nq2_answer', {
              quiz_path: QUIZ_PATH, concern: concern, step_key: mkey,
              answer_values: vals.join(' | ').substring(0, 90),
              answer_count: vals.length, is_multi: true, is_change: mChange,
              seconds_on_step: Math.round((Date.now() - stepStart) / 1000)
            });
          }
        }
      });

      function sendAbandon() {
        if (done || abandonSent || maxStep < 1) return;
        abandonSent = true;
        track('nq2_quiz_abandon', {
          quiz_path: QUIZ_PATH, concern: concern,
          last_step_index: maxStep,
          last_step_event: STEP_EVENT[maxStep] || ('nq2_s_x_' + maxStep)
        });
      }
      window.addEventListener('pagehide', sendAbandon);
      window.addEventListener('beforeunload', sendAbandon);
    }

    function bootTracker(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll(ROOT_SELECTOR), initTracker);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { bootTracker(document); });
    } else {
      bootTracker(document);
    }
    document.addEventListener('shopify:section:load', function (event) { bootTracker(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nato-quiz-start"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.natoQuizStartInitialized) return;
    window.natoQuizStartInitialized = true;

    // ----- nq2 GA4 helper (scoped, idempotent) -----
    function nq2EnsureGtag() {
      if (window.__nq2GtagReady) return;
      window.__nq2GtagReady = true;
      window.dataLayer = window.dataLayer || [];
      if (typeof window.gtag !== 'function') {
        window.gtag = function () { window.dataLayer.push(arguments); };
      }
      if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
        var s = document.createElement('script');
        s.async = true;
        s.src = 'https://www.googletagmanager.com/gtag/js?id=G-F7R9Y6YWDR';
        s.setAttribute('data-nq2-gtag', '1');
        document.head.appendChild(s);
        window.gtag('js', new Date());
        window.gtag('config', 'G-F7R9Y6YWDR');
      }
    }
    function nq2Track(name, params) {
      nq2EnsureGtag();
      try { window.gtag('event', name, params || {}); } catch (e) {}
    }

    // Funnel entry: start page (concern selection) viewed.
    nq2Track('nq2_start_view', { referrer: document.referrer || 'direct' });

    document.addEventListener('click', function (event) {
      var option = event.target.closest('[data-nato-quiz-option]');
      if (!option) return;

      var href = option.getAttribute('href');
      if (!href || href === '#') return;

      event.preventDefault();

      var root = option.closest('[data-nato-quiz-start]');
      if (root) {
        root.querySelectorAll('[data-nato-quiz-option]').forEach(function (item) {
          item.classList.remove('is-selected');
        });
      }

      option.classList.add('is-selected');

      var concernValue = option.dataset.natoQuizValue || '';

      try {
        window.localStorage.setItem('nato_quiz_start_concern', concernValue);
      } catch (error) {}

      // Which of the 5 concerns the user picked + where it routes.
      nq2Track('nq2_concern_select', {
        concern: concernValue || 'unknown',
        target_path: href
      });

      window.setTimeout(function () {
        window.location.href = href;
      }, 180);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
